(ns manage.resource.export
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.export/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc db :resource.export/post {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render :api/adset-exports url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.export/post-success]
      :on-failure [:resource.export/post-failure]
      :params payload}}))

(rf/reg-event-db :resource.export/post-success
  (fn [db [_ data]]
    (assoc db :resource.export/post {:state :success :value data})))

(rf/reg-event-db :resource.export/post-failure
  (fn [db _]
    (assoc db :resource.export/post {:state :failure})))
